import store from "./store";

export default {
  install(Vue, { store: rootStore }) {
    rootStore.registerModule("common", store);
  }
};
